import React from 'react';
import { Button } from 'react-bootstrap';
import { useMode } from '../../contexts/ModeContext';

const ModeButton = () => {
  const { isModeAdmin, toggleMode } = useMode();

  return (
    <Button variant="primary" onClick={toggleMode} style={{padding: '0 5px', marginRight:'10px'}}>
      {isModeAdmin ? 'Basculer en mode Standard' : 'Basculer en mode Admin'}
    </Button>
  );
};

export default ModeButton;
